/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isNil } from 'lodash';
import cns from 'classnames';
import { withRouter } from 'react-router-dom';
import { LEARNING_ASSET_TYPES, SECTION_ITEM_TYPES } from '../../../shared/Constants';
import Page from '../../../shared/components/Page';
import FullPageContent from '../../../shared/components/FullPageContent';
import { getSlideObject } from '../../../shared/utils/WorkspaceUtils';
import { getLearningAsset, getPastLearningAssets, getWelcomeAsset } from '../../../shared/actions';
import VerbSelect from '../../../shared/components/formComponents/inputs/VerbSelect';
import FullPageLoadingIndicator from '../../../shared/components/FullPageLoadingIndicator';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class PreviewLearningAsset extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        getLearningAsset: PropTypes.func.isRequired,
        getWelcomeAsset: PropTypes.func.isRequired,
        learningAsset: PropTypes.object.isRequired,
        profile: PropTypes.object,
        learningAssetType: PropTypes.string
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            selectedVersionId: null,
            pastVersions: [],
            loading: true
        };
    }

    UNSAFE_componentWillMount() {
        return this._getAsset({
            learningAssetId: this.props.match.params.id,
            getFullProjection: true,
            learningAssetType: this.props.match.params.type
        }).then(() => this.setState({ loading: false }));
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        return getPastLearningAssets({
            learningAssetId: id,
            pathsContext: this.context.pathsWeb
        }).then((pastVersions) => this.setState({ pastVersions, selectedVersionId: id }));
    }

    _getAsset = ({ learningAssetId, getFullProjection, learningAssetType }) => {
        const { getLearningAsset, getWelcomeAsset } = this.props;
        return learningAssetType === 'welcome'
            ? getWelcomeAsset({ welcomeAssetId: learningAssetId, pathsContext: this.context.pathsWeb })
            : getLearningAsset({ learningAssetId, getFullProjection, pathsContext: this.context.pathsWeb });
    };

    _createSlides = () => {
        const { learningAsset, profile } = this.props;
        const { pastVersions, selectedVersionId } = this.state;
        let assetToRender;
        if (selectedVersionId && selectedVersionId !== learningAsset._id) {
            const versionsById = {};
            pastVersions.forEach((asset) => {
                versionsById[asset._id] = asset;
            });
            assetToRender = versionsById[selectedVersionId];
        } else {
            assetToRender = learningAsset;
        }
        const slides = [];
        let sectionItems = [];
        const sections = (assetToRender && assetToRender.sections) || [];
        sections.forEach((section) => {
            sectionItems = sectionItems.concat(get(section, 'sectionItems', []));
        });

        sectionItems.forEach((sectionItem) => {
            if (isNil(sectionItem)) {
                return;
            }

            if (learningAsset.type === LEARNING_ASSET_TYPES.FEEDBACK) {
                return;
            }

            const sectionItemName = sectionItem.name || '';
            const formattedSectionItemType = (sectionItem.type || '').toLocaleUpperCase();
            const workspaceProps = { currentUserTrack: { track: learningAsset }, currentUser: profile };
            const eventHandlers = {};
            let trackData;
            let newSlideObject;

            if (formattedSectionItemType === SECTION_ITEM_TYPES.THIS_OR_THAT_PERMUTATION_CONTENT) {
                const questions = get(sectionItem, 'content.questions', []);
                questions.forEach((question, i) => {
                    const sectionItemCopy = JSON.parse(JSON.stringify(sectionItem));
                    const questionsCopy = JSON.parse(JSON.stringify(questions));
                    questionsCopy.splice(i, 1);
                    sectionItemCopy.content.questions = [question];
                    trackData = {
                        formattedSectionItemType,
                        sectionItem: sectionItemCopy,
                        sectionItems,
                        sectionItemName
                    };
                    newSlideObject = getSlideObject({ trackData, workspaceProps, eventHandlers, isPreview: true, pathsContext : this.context.pathsWeb });
                    slides.push(newSlideObject);
                });
            } else {
                trackData = { formattedSectionItemType, sectionItem, sectionItems, sectionItemName };
                newSlideObject = getSlideObject({ trackData, workspaceProps, eventHandlers, isPreview: true, pathsContext : this.context.pathsWeb });
                slides.push(newSlideObject);
            }
        });
        return slides;
    };

    handleVersionPreviewChange = (value) => this.setState({ selectedVersionId: value._id });

    _makeVersionOptions = () => {
        const { learningAsset, learningAsset: { updatedBy: { firstName = '', lastName = '' } = {} } = {} } = this.props;
        const availableVersions = this.state.pastVersions.sort((b, a) => {
            if (a.updatedOn > b.updatedOn || a._id === learningAsset._id) {
                return 1;
            }
            return -1;
        });
        const options = availableVersions.map((asset) => {
            const { updatedOn, updatedBy: { firstName = '', lastName = '' } = {} } = asset;
            const date = new Date(updatedOn);
            const dateString = date.toDateString();
            const label =
                asset._id === learningAsset._id
                    ? `Current version: ${firstName} ${lastName}`
                    : `Updated on ${dateString}: ${firstName} ${lastName}`;
            return { _id: asset._id, label };
        });
        return [{ _id: learningAsset._id, label: `Current version: ${firstName} ${lastName}` }, ...options];
    };

    render() {
        const { learningAsset } = this.props;
        if (this.state.loading) {
            return <FullPageLoadingIndicator />;
        }
        const { selectedVersionId } = this.state;

        const versionSelectOptions = this._makeVersionOptions();

        const slides = this._createSlides();
        const slideComponents = [];
        slides.forEach((slide, i) => {
            if (slide) {
                const SlideComponent = slide.component;
                const props = slide.componentProps;
                slideComponents.push(
                    <div key={`${slide.id}${i}`} className={'slide-preview'}>
                        <SlideComponent {...props} />
                    </div>
                );
            }
        });

        const mainClass = cns(
            'workspaceMain',
            'container-fluid',
            'col-12',
            'col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2'
        );
        return (
            <Page>
                <FullPageContent className={'activityWorkspace preview-learning-asset'}>
                    <div className={'row header-row col-12 mx-auto col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2'}>
                        <div className={'col-12 col-sm-4 col-sm-offset-6 me-auto version'}>
                            <div className={'label col-2'}>Version:</div>
                            <VerbSelect
                                value={selectedVersionId}
                                onChange={this.handleVersionPreviewChange}
                                options={versionSelectOptions}
                                placeholder={'Select version'}
                                labelKey={'label'}
                                valueKey={'_id'}
                                className={'col-10'}
                            />
                        </div>
                        {!!learningAsset.name && (
                            <div className={'col-12 col-sm-4 col-sm-offset-6 ms-auto title'}>
                                <div className={'label col-2'}>Title:</div>
                                <div className={'col-10 asset-title-label'}>{learningAsset.name}</div>
                            </div>
                        )}
                    </div>
                    <div className={'row'}>
                        <div className={mainClass}>
                            <div className={'workspacePlayer'}>{slideComponents}</div>
                        </div>
                    </div>
                </FullPageContent>
            </Page>
        );
    }
}

export const makeMapStateToProps = () => {
    const derivedMapStateToProps = (state, ownProps) => {
        const {
            learningAssets,
            welcomeAssets,
            profiles,
            auth: { loggedInUserId }
        } = state;
        const learningAsset =
            ownProps.match.params.type === 'welcome'
                ? welcomeAssets.byId[ownProps.match.params.id]
                : learningAssets.byId[ownProps.match.params.id];
        return {
            learningAsset,
            profile: profiles.byId[loggedInUserId]
        };
    };

    return derivedMapStateToProps;
};

export const mapDispatchToProps = (dispatch) => ({
    getLearningAsset: (params) => dispatch(getLearningAsset(params)),
    getWelcomeAsset: (params) => dispatch(getWelcomeAsset(params))
});

export const PreviewLearningAssetComponent = PreviewLearningAsset;
export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(PreviewLearningAsset));
